import StringUtils from './stringUtils/index'
import DateUtils from "./dateUtil/index";

const install = (Vue) => {
    Vue.prototype.$StringUtils = StringUtils;
    Vue.prototype.$DateUtis = DateUtils;
};
export default {install}
